import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import { Link } from 'react-router-dom'
import OurMallsContent from '../OurMallsContent/OurMallsContent'
import SideModal from '../../ui/SideModal/SideModal'

import media from '../../../services/generateMediaQueries'

const StyledSideModal = styled(SideModal)`
  max-width: 960px;
  overflow-x: hidden;
`

const Container = styled.div`
  padding: 40px;
`

const Content = styled.div`
  min-width: calc(100% - 250px);

  ${media.lessThan('small')`
    min-width: 100%;
  `}
`

const Title = styled.h1`
  font-family: var(--font-family-ayala-display-sans);
  margin: 0;
  margin-bottom: 40px;
`

const Error = styled.h1`
  margin: 0;
  margin-bottom: 40px;
  color: red;
`

const ContentWrapper = styled.div`
  display: flex;

  ${media.lessThan('small')`
    transform: translateX(-250px);

    ${props =>
      props.sideBarToggled &&
      css`
        transform: translateX(0px);
      `}
  `}

  transition: all var(--animation-duration) var(--animation-easing);
`

const SideBar = styled.div`
  min-width: 250px;
  padding-right: 2rem;
`

const StyledLink = styled(Link)`
  display: block;
  cursor: pointer;
  padding: 10px 0;
  font-weight: ${({ selected }) =>
    selected ? 'var(--font-weight-boldest)' : 'var(--font-weight)'};
  text-decoration: none;
`

class OurMallsModal extends React.Component {
  constructor(props) {
    super(props)

    this.mallImageSlider = React.createRef()

    this.state = {
      currentMall: null,
      sideBarState: false,
    }
  }

  componentDidMount() {
    this.resetCurrentMall()
  }

  componentDidUpdate(prevProps, prevState) {
    const { malls } = this.props
    const { currentMall } = this.state

    if (prevProps.malls !== malls) {
      this.resetCurrentMall()
    }

    if (prevState.currentMall !== currentMall) {
      this.resetSlider()
    }
  }

  mallImageSliderNext = () => {
    this.mallImageSlider.current.slickNext()
  }

  mallImageSliderPrev = () => {
    this.mallImageSlider.current.slickPrev()
  }

  resetSlider = () => {
    const sliderRef = this.mallImageSlider.current

    if (sliderRef) {
      this.mallImageSlider.current.slickGoTo(0)
    }
  }

  resetCurrentMall = () => {
    const { malls } = this.props

    const currentMall = malls[0] || null

    this.setState({
      currentMall,
    })
  }

  setCurrentMall = mall => {
    this.setState({
      currentMall: mall,
    })
  }

  toggleSideBar = () => {
    const { sideBarState } = this.state

    this.setState({
      sideBarState: !sideBarState,
    })
  }

  render() {
    const {
      show,
      onClose,
      loading,
      malls,
      baseUrl,
      mallError,
      currentMall,
    } = this.props

    const { sideBarState } = this.state

    return (
      <StyledSideModal show={show} onClose={onClose} loading={loading}>
        {mallError && (
          <Container>
            <Error>Failed to load Malls</Error>
          </Container>
        )}
        {malls.length > 0 && (
          <Container>
            <ContentWrapper sideBarToggled={sideBarState}>
              <SideBar>
                <Title>Our Malls</Title>
                {malls.map(({ id, name, slugName }) => (
                  <StyledLink
                    to={`${baseUrl}/${slugName || id}`}
                    key={id}
                    selected={
                      currentMall &&
                      (slugName || id) ===
                        (currentMall.slugName || currentMall.id)
                    }
                    onClick={this.toggleSideBar}
                  >
                    {name}
                  </StyledLink>
                ))}
              </SideBar>
              {currentMall && (
                <Content>
                  <OurMallsContent
                    onToggleSideBar={this.toggleSideBar}
                    data={currentMall}
                  />
                </Content>
              )}
            </ContentWrapper>
          </Container>
        )}
      </StyledSideModal>
    )
  }
}

OurMallsModal.defaultProps = {
  show: false,
  handleClose: null,
  malls: [],
}

OurMallsModal.propTypes = {
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  malls: PropTypes.array,
}

export default OurMallsModal
